/**
 * Por que não há preço, em português (F306): a frase do balcão do site e do
 * orçamento do celular quando um item não pode entrar. O pacote de preço
 * devolve só o código; a frase é da interface, e as duas dizem a mesma.
 */
export const UNRESOLVED_PRICE_TEXT = {
    'no-price-list': 'A conta não tem uma tabela de preço padrão.',
    'price-list-archived': 'Esta tabela está arquivada.',
    'no-price-for-variant': 'Este produto não tem preço nesta tabela.',
    'no-applicable-tier': 'Nenhuma faixa vale para esta quantidade neste momento.',
    'invalid-quantity': 'A quantidade precisa ser maior ou igual a zero.',
};
//# sourceMappingURL=pricing.js.map